import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
// import { Video } from '@/components/elements/Video'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'

import { VideoInfo } from '@/types/video'

type VideoProps = {
  videoInfoList: readonly VideoInfo[]
}

export const VideoPage = ({ videoInfoList }: VideoProps) => {
  const pageTitle = {
    title: 'Newsroom',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Newsroom', path: '/en/news' },
    { name: 'Video Library', path: '' },
  ]

  return (
    <>
      <Head
        title="Video Library "
        description="Watch promotional videos from TRIAL Holdings, Inc."
        ogp={{ type: 'article', url: 'en/news/video/' }}
      />
      <TitleLayout
        {...pageTitle}
        breadCrumbs={breadCrumbs}
        isRequiredBackground
      >
        <Container>
          <SectionTitle
            enTitleText="Video Library"
            subTitleText=""
            color="normal"
          />
          <Spacer h={{ sp: 50, pc: 63 }} />
          <CategoryTitle>Strategy Introduction Video</CategoryTitle>
          <Spacer h={{ sp: 40, pc: 52 }} />
          {videoInfoList.length > 0 && (
            //  ※緊急で直接動画を埋め込んでいる。後にNewtの英語版で対応する。
            <VideoList>   
                <VideoItem >
                 <iframe width="316" height="217" src="https://www.youtube.com/embed/sHjOVeTEClM"></iframe>
                  <VideoTitle>Retail AI - Retail Revolution (EN)</VideoTitle>
                </VideoItem>
            </VideoList>
          )}
        </Container>
      </TitleLayout>
    </>
  )
}

const Container = styled.div`
  width: 1040px;
  padding: 70px 0 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    padding: 40px 20px 80px;
    width: 100%;
  }
`

const CategoryTitle = styled.h4`
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 1.68px;
  line-height: 42px;
  color: ${theme.colors.trialBlue};

  @media screen and (max-width: 1047px) {
    font-size: 20px;
    letter-spacing: 1.2px;
    line-height: 28px;
  }
`

const VideoItem = styled.div`
  width: 316px;

  @media screen and (max-width: 1047px) {
    width: 350px;
  }
`

const VideoList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 46px;
`

const VideoTitle = styled.div`
  font-size: 16px;
  letter-spacing: 1.6px;
  line-height: 22px;
  color: ${theme.colors.textTitle};
  margin-top: 14px;

  @media screen and (max-width: 1047px) {
    letter-spacing: 0.96px;
    margin-top: 10px;
  }
`
